import { Role } from '@/api/types'

export default [
    {
        name: 'user_settings',
        path: '/user/settings',
        meta: {
            requiredRole: Role.EMPLOYEE,
            noBackground: false,
        },
        component: () => import(/* webpackChunkName: "user_settings" */ '../../views/User/Settings.vue'),
    },
]
